import {SDKRequest} from '../../../../shared/DiscordActivityTypes.ts'
import {UICoinProductView} from '../../../shared/scripts/store/UICoinProductView.ts'
import {DiscordInstance} from '../discord/DiscordInstance.ts'
import {CA} from '../../../shared/scripts/analytics/Analytics.ts'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables.ts'
import {UIDStoreBodyController} from './UIDStoreBodyController.ts'
import {AudioManager, AudioType} from '@colonist/audio'

export class UIDCoinProductView extends UICoinProductView {
    protected override handleBuyButtonClicked() {
        AudioManager.play(AudioType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreClickedPurchaseCoinDiscord, this.product.price)

        if(UIUtilsEjsVariables.isUserOnDiscordMobile) {
            UIDStoreBodyController.showUnavailableOnMobilePopup()
            return
        }

        void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseCoins, this.product.type)
    }
}
